import styled from 'styled-components/macro';
import { GlobalColors, Rules } from 'src/App/Styles/Globals';
import { column, row_center_both } from 'src/App/Styles/styles-helpers';

export const HomeContain = styled.div`
	flex: 1;
	${column}
	overflow:hidden;
`;
export const HomeTabWrapper = styled.div`
	height: 40px;
	display: flex;
	background: ${GlobalColors.separator};
	font-size: 0.75em;
`;
export const HomeTabItem = styled.div<{ selected: boolean }>`
	${row_center_both}
	gap: .5rem;
	cursor: pointer;
	flex: 1 1 auto;
	height: 100%;
	font-weight: 900;
	color: ${({ selected }) => (selected ? GlobalColors.pinkSamen : GlobalColors.inactiveTabs)};
	${row_center_both}
	transition: .2s;
	&:hover {
		background: #26264350;
	}
	svg path {
		fill: currentColor;
	}
`;
export const HomeTabTxt = styled.div`
	@media (max-width: 467px) {
		display: none;
	}
`;
export const HomeTabSeparator = styled.div`
	height: 60%;
	width: 1px;
	background: ${GlobalColors.transparentWhite};
	margin: auto;
`;

export const HomeTopbar = styled.div`
	position: relative;
	height: 80px;
	${row_center_both}
	background-color: ${GlobalColors.slightGrey};
	padding: 1em;
	color: ${GlobalColors.white1};
	border-radius: ${Rules.radiusContainer};
	overflow: hidden;
	svg {
		position: absolute;
		width: 50px;
		opacity: 0.1;
		animation: SvgSubtle 10s forwards infinite;
	}
	svg:nth-of-type(1) {
		top: 30px;
		right: 0;
	}
	svg:nth-of-type(2) {
		width: 80px;
		top: 20px;
		left: -40px;
	}
	@keyframes SvgSubtle {
		0% {
			transform: translateY(0);
			opacity: 0.1;
		}
		50% {
			transform: translateY(-40px);
			opacity: 0.2;
		}
		100% {
			transform: translateY(0);
			opacity: 0.1;
		}
	}
`;
